import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanEventType extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanEventType';
}
